const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "ApplyCode",
		label: "申请单号",
		columnwidth: 180,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100,
	},
	{
		prop: "MFName",
		label: "生产厂商",
		columnwidth: 80,
	},
	{
		prop: "SampleTypeName",
		label: "样品类型",
		columnwidth: 160,
	},
	{
		prop: "InvName",
		label: "产品名称",
		columnwidth: 140,
	},
	{
		prop: "InvAddCode",
		label: "产品型号",
		columnwidth: 120,
	},
	{
		prop: "Quantity",
		label: "数量",
		columnwidth: 80,
	},
	{
		prop: "PurchaseRatio",
		label: "品类占比",
		columnwidth: 100,
	},
	{
		prop: "Purpose",
		label: "用途",
		columnwidth: 160,
	},
	{
		prop: "Remark",
		label: "备注",
		columnwidth: 130,
	},
	{
		prop: "DeliveryAddress",
		label: "收货地址",
		columnwidth: 130,
	},
	{
		prop: "AreaRatio",
		label: "小区占比",
		columnwidth: 100,
	},
	{
		prop: "RegionRatio",
		label: "大区占比",
		columnwidth: 100,
	},{
		prop: "CountryRatio",
		label: "全国占比",
		columnwidth: 100,
	},{
		prop: "SalerInChargeName",
		label: "负责销售",
		columnwidth: 100,
	},{
		prop: "AdvTypeName",
		label: "分类",
		columnwidth: 100,
	},
	{
		prop: "CusName",
		label: "经销商",
		columnwidth: 150,
	},
	{
		prop: "HPName",
		label: "医院",
		columnwidth: 150,
	},
	{
		prop: "ApproveTime",
		label: "生成日期",
		columnwidth: 125,
	},
	{
		prop: "CreatorName",
		label: "业务员",
		columnwidth: 150,
	}
];
export default headerData;